export default "__VITE_ASSET__DEw0EPNL__"